<template>
  <div class="proj-bid-reply-rule-edit" id="projProReplyRuleEdit">
    <ProjProReplyHeader @beforeRouteChange="saveDraft" />
    <div class="panel-box">
      <ProjectViewSummary class="viewSummary" :project="project" />
    </div>
    <div class="eb-line"></div>
    <div class="rule-answer-edit">
      <ProjRuleAnswerEditList :ruleAnswerList="ruleAnswerList" :uploadUrl="uploadUrl" />
      <div class="rule-one-key-response">
        <el-button v-if="isShow == 1" class="eb-button-red eb-button-small" @click="oneKeyResponse">一键应答</el-button>
      </div>
    </div>
    <div class="eb-button-group">
      <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="saveDraft">保存草稿</el-button>
      <!-- <router-link class="eb-button-group-btn" :to="{path:'/projpro/reply/purchaselist/'+projectId+'/'+replyId}"> -->
      <el-button @click="isCheckAuth" class="eb-button-orange eb-button-big">采购清单 &gt;</el-button>
      <!-- </router-link> -->
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import EventBus from '@/plugins/event-bus';
import ProjProReplyHeader from '@/components/project/pro/reply/ProjProReplyHeader';
import ProjectViewSummary from '@/components/project/common/ProjectViewSummary';
import ProjRuleAnswerEditList from '@/components/project/common/rule-answer-edit/ProjRuleAnswerEditList';
import { handleProjRuleAnswerList } from '@/services/proj/project-service';
import { detailProjectResponse, isCheckSupplierBtnAuth } from '@/services/proj/pro-project-service';
import { listAnswer, editAnswer, oneKeyResponse } from '@/services/proj/pro-rule-answer-service';

export default {
  name: 'projProReplyRuleEdit',
  components: {
    ProjProReplyHeader,
    ProjectViewSummary,
    ProjRuleAnswerEditList
  },
  filters: {},
  data() {
    return {
      projectId: this.$route.params.projectId,
      replyId: this.$route.params.replyId,
      user: this.$store.state.user.userInfo,
      project: {},
      ruleAnswerList: [],
      uploadUrl: '',
      isShow: 1,
      btnParams: {
        projectId: this.$route.params.projectId,
        type: '3'
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getProjectDetail();
    this.getProjReplyRuleAnswer();

    // 修改规则应答
    EventBus.$on('projReplyEditRuleAnswer', async (params, done) => {
      try {
        let { data } = await editAnswer(params);
        if (data.returnCode !== '01') {
          throw new Error('修改规则应答失败');
        } else {
          this.$message.success('修改规则应答成功');
        }
        done.success(data);
      } catch (err) {
        this.$message.error(err.message);
        done.error(err);
      }
    });
  },
  mounted() {},
  methods: {
    async saveDraft() {
      try {
        let { data } = await isCheckSupplierBtnAuth(this.btnParams);
        if (data.returnCode === '01') {
          this.$message.success('保存项目规则应答成功！');
        } else if (data.returnCode === '00') {
          this.$message.error(data.message);
          return;
        } else {
          this.$message.error('操作失败');
        }
      } catch (error) {
        this.$message.error('网络异常请稍后重试');
      }
    },
    // 获取招标项目详情，包含shopList,project
    async getProjectDetail() {
      try {
        let { data } = await detailProjectResponse(this.projectId);
        if (data.returnCode === '01') {
          this.project = data.project;
          // 初始化规则编辑上传url
          this.uploadUrl =
            '/project/upload_attachment?channel=ra&date=' +
            moment(this.project.createTime).format('YYYYMMDD') +
            '&projectId=' +
            this.replyId;
        } else if (data.returnCode === '00') {
          this.$confirm('您无权访问此项目。项目不存在，或已经被撤回/取消。', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            confirmButtonClass: 'eb-cancle-button',
            cancelButtonClass: '',
            type: '',
            center: true,
            showClose: false,
            customClass: 'eb-comfirm',
            showCancelButton: false
          })
            .then(() => {
              window.history.go(-1);
            })
            .catch(() => {
              window.history.go(-1);
            });
        } else {
          throw new Error('加载项目详情失败！');
        }
      } catch (err) {
        this.$message.error(err.message);
      }
    },
    // 获取获取规则应答明细
    async getProjReplyRuleAnswer() {
      try {
        let { data } = await listAnswer(this.projectId, this.user.userid);
        if (data.returnCode === '01') {
          this.ruleAnswerList = handleProjRuleAnswerList(data.ruleList);
          if (JSON.parse(JSON.stringify(this.ruleAnswerList)).length === 0) {
            this.isShow = 0;
          }
        } else {
          throw new Error('加载项目规则应答列表失败');
        }
      } catch (err) {
        this.$message.error(err.message);
      }
    },
    // 编辑应答
    async editRuleAnswer(params) {
      try {
        let { data } = await editAnswer(params);
        if (data.returnCode === '01') {
          this.$message.success('修改规则应答成功');
        } else {
          throw new Error('修改规则应答失败');
        }
      } catch (err) {
        this.$message.error(err.message);
      }
    },
    // 一键应答
    async oneKeyResponse() {
      try {
        let { data } = await isCheckSupplierBtnAuth(this.btnParams);
        if (data.returnCode === '01') {
          let { data } = await oneKeyResponse(this.projectId, this.user.userid);
          if (data.returnCode === '01') {
            this.getProjReplyRuleAnswer();
            this.$message.success('一键应答成功！');
          } else {
            throw new Error('一键应答失败');
          }
        } else if (data.returnCode === '00') {
          this.$message.error(data.message);
          return;
        } else {
          this.$message.error('操作失败');
        }
      } catch (err) {
        this.$message.error(err.message);
      }
    },
    async isCheckAuth() {
      try {
        let { data } = await isCheckSupplierBtnAuth(this.btnParams);
        if (data.returnCode === '01') {
          this.$router.push('/projpro/reply/purchaselist/' + this.projectId + '/' + this.replyId);
        } else if (data.returnCode === '00') {
          this.$message.error(data.message);
          return;
        } else {
          this.$message.error('操作失败');
        }
      } catch (error) {
        this.$message.error('网络异常请稍后重试');
      }
    }
  },
  beforeDestroy() {
    EventBus.$off('projReplyEditRuleAnswer');
  }
};
</script>
<style lang="less">
.proj-bid-reply-rule-edit {
  .rule-answer-edit {
    position: relative;
    .rule-one-key-response {
      position: absolute;
      left: 670px;
      top: 46px;
    }
  }
}
</style>
